// Placeholder HTML written to value-slot blocks when blog/case-result metadata
// is cleared. Used by the metadata editor (use-metadata-editor-context) to keep
// the inline editor placeholder visible, and by the public renderer to hide the
// label+value pair when the value is just the placeholder.
//
// Keep in sync with Pages::ContentModels::SlotHtml::SLOT_PLACEHOLDERS in
// app/services/pages/content_models/slot_html.rb.
export const SLOT_PLACEHOLDERS = new Map<string, string>([
  ['author_value', '<p>[Author Name]</p>'],
  ['topics_value', '<p>[Topic]</p>'],
  ['published_date_value', '<p>[Month XX, 20XX]</p>'],
  ['attorney_value', '<p>[Attorney Name]</p>'],
  ['court_value', '<p>[Court Name]</p>'],
  ['practice_areas_value', '<p>[Practice Area]</p>'],
]);

export function getSlotPlaceholder(slot: string): string {
  return SLOT_PLACEHOLDERS.get(slot) ?? '';
}

export function isSlotPlaceholderContent(slot: string, content: unknown): boolean {
  const placeholder = SLOT_PLACEHOLDERS.get(slot);
  return Boolean(placeholder) && content === placeholder;
}

// Given a `_value` slot name, return the matching `_label` slot name (e.g.
// `author_value` -> `author_label`). Returns null when the slot isn't a known
// value slot.
export function pairedLabelSlot(valueSlot: string): string | null {
  if (!SLOT_PLACEHOLDERS.has(valueSlot)) return null;
  return valueSlot.replace(/_value$/, '_label');
}
